import React from "react";
import classNames from "classnames";
import styled from "styled-components";
import { Button } from "react-bootstrap";

export enum NavButtonVariants {
    OUTLINE_BLACK = 'outlineBlack',
    OUTLINE_WHITE = 'outlineWhite',
    RED_ROCK = 'redRock',
    BG_BLACK = 'bgBlack'
}

export default styled(({ className = '', customClass = '', variant, label, href = '', onClick = () => {}}) => {

    if (href) {
        return (
            <Button className={classNames(className, customClass, variant)} href={href}>{label}</Button>
        )
    }

    return (
        <Button className={classNames(className, customClass, variant)} onClick={onClick}>{label}</Button>
    )

})`
font-family: "National2";
font-weight: 500;
font-size: 0.778rem;
padding: 8px 24px;
text-transform: uppercase;
border-width: 1px;
border-style: solid;
border-radius: 4px;

&.outlineBlack {
    color: #000;
    background: #FFF;
    border-color: #000;
}

&.outlineWhite {
    color: #FFF;
    background: transparent;
    border-color: #FFF;
}

&.redRock {
    color: #FFF;
    background: var(--redRock);
    border-color: var(--redRock);
}

&.bgBlack {
    color: #FFF;
    background: #000;
    border-color: #000;
}

&:hover, &:active, &:focus {
    &.outlineBlack {
        color: #FFF!important;
        background: #000!important;
    }

    &.outlineWhite {
        color: #000!important;
        background: #FFF!important;
    }

    &.redRock {
        color: var(--redRock)!important;
        background: #FFF!important;
    }

    &.bgBlack {
        background: var(--redRock)!important;
        border-color: var(--redRock)!important;
    }
}

@media(max-width:380px) {
    &.login-button {
        padding-left: 0.5rem;
        padding-right: 0.5rem
    }
}
`
